import { render, staticRenderFns } from "./FollowUpView.vue?vue&type=template&id=fe9996a4"
import script from "./FollowUpView.vue?vue&type=script&lang=js"
export * from "./FollowUpView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports